export default __webpack_public_path__ + "static/media/FileUpload.fc001bfe.svg";